import { graphql } from "gatsby";
import React from "react";
import { HomeSection } from "../components/home-section";
import { Layout } from "../components/layout";
import "../fragments/link";
import { parseLink } from "../utils/link";
import { notEmpty } from "../utils/utils";

// react component that takes typed graphql results as prop
const ArticlesPage: React.FC<{ data: Queries.HomepageQuery }> = ({ data }) => {
  return (
    <Layout noBreadcrumbs>
      {data.strapiHomepage &&
        data.strapiHomepage.sections &&
        data.strapiHomepage.sections.map((section, i) => {
          if (!section) return null;
          return (
            <HomeSection
              key={section.id}
              title={
                section.main_category
                  ? section.main_category.name
                  : "no main category"
              }
              first={i === 0}
              anchorTag={
                section.main_category ? section.main_category.slug : section.id
              }
              otherTitles={data.strapiHomepage?.sections
                ?.filter(
                  (otherSection) =>
                    otherSection && otherSection.id !== section.id,
                )
                .filter((section) => !!section)
                .map((section) => ({
                  name: section?.main_category
                    ? section.main_category.name
                    : "no main category",
                  anchorTag: section?.main_category
                    ? section.main_category.slug
                    : section?.id,
                }))}
              subLinks={
                section.sub_links
                  ? section.sub_links
                      ?.filter(notEmpty)
                      .map(parseLink)
                      .filter(notEmpty)
                  : null
              }
              mainLink={section.main_link ? parseLink(section.main_link) : null}
              textBlock={
                section.text_block?.data?.text_block ? section.text_block : null
              }
            />
          );
        })}
    </Layout>
  );
};

export default ArticlesPage;

export const query = graphql`
  query Homepage {
    strapiHomepage {
      sections {
        ...HomeSection
      }
    }
  }
`;
